import { Component, OnInit } from '@angular/core';
import { apiService } from 'app/services/api.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  fAQContent: any[] = [];
  aboutUsPageCode: string; 
  openAccordionIndex: number = -1;
  pageTitle: string = '';
  
  constructor(private api: apiService) { }

  ngOnInit() {
    // Assuming 'languageCode' is stored in localStorage
    const languageCode = localStorage.getItem('languageCode') || 'en'; // Use 'en' as default if not found
  
    // Assign a value to 'aboutUsPageCode'
    this.aboutUsPageCode = 'FAQs';
  
    this.api.getPageContent(this.aboutUsPageCode, languageCode).subscribe(response => {
      const rawContent = response.data.page_content;
      const doc = new DOMParser().parseFromString(rawContent, 'text/html');
      const accordionItems = doc.querySelectorAll('.accordion-item');
  
      accordionItems.forEach((item, index) => {
        const headingElement = item.querySelector('.accordion-header');
        const bodyElement = item.querySelector('.accordion-body');
  
        // Use optional chaining to safely access properties
        const heading = headingElement?.textContent?.trim() || '';
        const body = bodyElement?.innerHTML || '';
        const collapseId = `collapse${index + 1}`;
        const headingId = `heading${index + 1}`;
        this.pageTitle = response.data.page_title;
        this.fAQContent.push({ heading, body, collapseId, headingId });
        if (this.fAQContent.length > 0) {
          this.openAccordion(0);
        }
      });
    });
  }

  // Function to toggle the accordion item
  toggleAccordion(index: number): void {
    if (this.openAccordionIndex === index) {
      // Clicking on an already open accordion, close it
      this.openAccordionIndex = -1;
    } else {
      // Clicking on a different accordion, toggle it
      this.openAccordion(index);
    }
  }

  // Function to open a specific accordion item
  openAccordion(index: number): void {
    this.openAccordionIndex = index;
  }
  

}
